// RB-MY01-PalmGarden.web/src/pages/AdminLoginPage.tsx
import React from 'react';
import AdminLoginForm from './AdminLoginForm';
import '../styles/auth.css';

const AdminLoginPage: React.FC = () => {
  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-content">
          <div className="auth-logo">
            <h1>Palm Garden Admin</h1>
          </div>
          <AdminLoginForm />
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;